import { KYMW2000InputModel } from './vo/kymw2000-input.model'
import { TempSelectedSummaryByBuyer } from './vo/temp-selected-summary-by-buyer.model';
import { TempSelectedSummary } from './vo/temp-selected-summary.model';
import { OrderNumQuotaSelectedSummary } from './vo/order-num-quota-selected-summary.model';

/**
 * 選定済商品数一覧の値を管理するクラス
 *
 * @export KYMW2000Model
 * @class KYMW2000Model
 */
export class KYMW2000Model {

  funcID = ''
  orderCode = '';
  catalogId = '';
  mediumType = '';
  mediumList = [];
  coopCode = '';
  deptCoopCode = '';
  buyerCoopCode = '';
  orderNumQuota = '';
  origineSource: KYMW2000InputModel;
  tempDeptRaw: TempSelectedSummary[] = [];
  tempDept = [];
  tempBuyerRaw: TempSelectedSummaryByBuyer[] = [];
  tempBuyer = [];
  orderDeptRaw: OrderNumQuotaSelectedSummary[] = [];
  orderDept = [];
  multiPublishFlg = '0';
  multiPublishItemCnt = false;
  isOrderNumQuotaButton = false;
  isMultiPublishItemCnt = false;
  fileName='';

  get selectedMediumName() {
    const selectedList = this.mediumList.find(item => item.MediumType === this.mediumType);
    return selectedList ? selectedList.MediumName : '';
  }

  updateMediumList() {
    if (this.mediumList.length === 0) {
      return;
    }
   
    const list = this.mediumList.map(item => ({
      MediumType: item.MediumType,
      MediumName: item.MediumName,
      MediumTypeName: `${item.MediumType}:${item.MediumName}`,
    }));
   
    const allItem = {
      MediumType: '',
      MediumName: 'ALL',
      MediumTypeName: 'ALL',
    };

    if(!list.some(item => item.MediumType === this.mediumType)){
      this.mediumType = '';
    }

    return this.mediumList = [allItem, ...list];
  }

  updateTempDept() {
    if (this.tempDeptRaw.length === 0) {
      this.tempDept = [];
      return;
    }
   
    const list = [];
    this.tempDeptRaw[0].SelectedNumList.forEach((_) => {
      list.push({
        ClassCode: _.ClassCode,
        ClassName: _.ClassName,
        ClassGoodsCount: this.toDisplayCount(_.ClassGoodsCount),
        FreezedGoodsCount: this.toDisplayCount(_.FreezedGoodsCount),
        RefrigeratedGoodsCount: this.toDisplayCount(_.RefrigeratedGoodsCount),
        RoomTempGoodsCount: this.toDisplayCount(_.RoomTempGoodsCount),
        VegetableGoodsCount: this.toDisplayCount(_.VegetableGoodsCount),
        BreadGoodsCount: this.toDisplayCount(_.BreadGoodsCount),
        OtherStockedGoodsCount: this.toDisplayCount(_.OtherStockedGoodsCount)
      });
    })
   
    const totalRow = {
      ClassCode: 'total',
      ClassName: '総選定数',
      ClassGoodsCount: this.toDisplayCount(this.tempDeptRaw[0].SelectedTotalNum.ClassGoodsCount),
      FreezedGoodsCount: this.toDisplayCount(this.tempDeptRaw[0].SelectedTotalNum.FreezedGoodsCount),
      RefrigeratedGoodsCount: this.toDisplayCount(this.tempDeptRaw[0].SelectedTotalNum.RefrigeratedGoodsCount),
      RoomTempGoodsCount: this.toDisplayCount(this.tempDeptRaw[0].SelectedTotalNum.RoomTempGoodsCount),
      VegetableGoodsCount: this.toDisplayCount(this.tempDeptRaw[0].SelectedTotalNum.VegetableGoodsCount),
      BreadGoodsCount: this.toDisplayCount(this.tempDeptRaw[0].SelectedTotalNum.BreadGoodsCount),
      OtherStockedGoodsCount: this.toDisplayCount(this.tempDeptRaw[0].SelectedTotalNum.OtherStockedGoodsCount),
    };
   
    list.push(totalRow);
    this.tempDept = list;
  }

  updateTempBuyer() {
    if (this.tempBuyerRaw.length === 0) {
      this.tempBuyer = [];
      return;
    }
  
    const list = [];
    this.tempBuyerRaw[0].SelectedNumList.forEach((_) => {
      list.push({
        MediumType: _.MediumType,
        MediumName: _.MediumName,
        ClassCode: _.ClassCode,
        ClassName: _.ClassName,
        BuyerCode: _.BuyerCode,
        BuyerName: _.BuyerName,
        FreezedGoodsCount: this.toDisplayCount(_.FreezedGoodsCount),
        RefrigeratedGoodsCount: this.toDisplayCount(_.RefrigeratedGoodsCount),
        RoomTempGoodsCount: this.toDisplayCount(_.RoomTempGoodsCount),
        VegetableGoodsCount: this.toDisplayCount(_.VegetableGoodsCount),
        BreadGoodsCount: this.toDisplayCount(_.BreadGoodsCount),
        OtherStockedGoodsCount: this.toDisplayCount(_.OtherStockedGoodsCount)
      });
    })
   
    const totalRow = {
      MediumType: '',
			MediumName: '',
      ClassCode: 'total',
      ClassName: '総選定数',
      BuyerCode: '',
			BuyerName: '',
      FreezedGoodsCount: this.toDisplayCount(this.tempBuyerRaw[0].SelectedTotalNum.FreezedGoodsCount),
      RefrigeratedGoodsCount: this.toDisplayCount(this.tempBuyerRaw[0].SelectedTotalNum.RefrigeratedGoodsCount),
      RoomTempGoodsCount: this.toDisplayCount(this.tempBuyerRaw[0].SelectedTotalNum.RoomTempGoodsCount),
      VegetableGoodsCount: this.toDisplayCount(this.tempBuyerRaw[0].SelectedTotalNum.VegetableGoodsCount),
      BreadGoodsCount: this.toDisplayCount(this.tempBuyerRaw[0].SelectedTotalNum.BreadGoodsCount),
      OtherStockedGoodsCount: this.toDisplayCount(this.tempBuyerRaw[0].SelectedTotalNum.OtherStockedGoodsCount),
    };
   
    list.push(totalRow);
    this.tempBuyer = list;
  }

  updateOrderDept() {
    if (this.orderDeptRaw.length === 0) {
      this.orderDept = [];
      return;
    }
   
    const list = [];
    this.orderDeptRaw[0].SelectedNumList.forEach((_) => {
      list.push({
        ClassCode: _.ClassCode,
        ClassName: _.ClassName,
        IbarakiGoodsCount: this.toDisplayCount(_.IbarakiGoodsCount),
        TochigiGoodsCount: this.toDisplayCount(_.TochigiGoodsCount),
        GunmaGoodsCount: this.toDisplayCount(_.GunmaGoodsCount),
        ChibaGoodsCount: this.toDisplayCount(_.ChibaGoodsCount),
        SaitamaGoodsCount: this.toDisplayCount(_.SaitamaGoodsCount),
        TokyoGoodsCount: this.toDisplayCount(_.TokyoGoodsCount),
        NaganoGoodsCount: this.toDisplayCount(_.NaganoGoodsCount),
        NiigataGoodsCount: this.toDisplayCount(_.NiigataGoodsCount),
      });
    })
   
    const totalRow = {
      ClassCode: 'total',
      ClassName: '総選定数',
      IbarakiGoodsCount: this.toDisplayCount(this.orderDeptRaw[0].SelectedTotalNum.IbarakiGoodsCount),
      TochigiGoodsCount: this.toDisplayCount(this.orderDeptRaw[0].SelectedTotalNum.TochigiGoodsCount),
      GunmaGoodsCount: this.toDisplayCount(this.orderDeptRaw[0].SelectedTotalNum.GunmaGoodsCount),
      ChibaGoodsCount: this.toDisplayCount(this.orderDeptRaw[0].SelectedTotalNum.ChibaGoodsCount),
      SaitamaGoodsCount: this.toDisplayCount(this.orderDeptRaw[0].SelectedTotalNum.SaitamaGoodsCount),
      TokyoGoodsCount: this.toDisplayCount(this.orderDeptRaw[0].SelectedTotalNum.TokyoGoodsCount),
      NaganoGoodsCount: this.toDisplayCount(this.orderDeptRaw[0].SelectedTotalNum.NaganoGoodsCount),
      NiigataGoodsCount: this.toDisplayCount(this.orderDeptRaw[0].SelectedTotalNum.NiigataGoodsCount),
    };

    const maxRow = {
      ClassCode: 'max',
      ClassName: '最大件数',
      IbarakiGoodsCount: this.multiPublishItemCnt ? null : this.toDisplayCount(this.orderDeptRaw[0].MaxNum.IbarakiGoodsCount),
      TochigiGoodsCount: this.multiPublishItemCnt ? null : this.toDisplayCount(this.orderDeptRaw[0].MaxNum.TochigiGoodsCount),
      GunmaGoodsCount: this.multiPublishItemCnt ? null : this.toDisplayCount(this.orderDeptRaw[0].MaxNum.GunmaGoodsCount),
      ChibaGoodsCount: this.multiPublishItemCnt ? null : this.toDisplayCount(this.orderDeptRaw[0].MaxNum.ChibaGoodsCount),
      SaitamaGoodsCount: this.multiPublishItemCnt ? null : this.toDisplayCount(this.orderDeptRaw[0].MaxNum.SaitamaGoodsCount),
      TokyoGoodsCount: this.multiPublishItemCnt ? null : this.toDisplayCount(this.orderDeptRaw[0].MaxNum.TokyoGoodsCount),
      NaganoGoodsCount: this.multiPublishItemCnt ? null : this.toDisplayCount(this.orderDeptRaw[0].MaxNum.NaganoGoodsCount),
      NiigataGoodsCount: this.multiPublishItemCnt ? null : this.toDisplayCount(this.orderDeptRaw[0].MaxNum.NiigataGoodsCount),
    };
   
    list.push(totalRow);
    list.push(maxRow);
    this.orderDept = list;
  }

  /**
   * ファイル名を更新する
   *
   * @param {*} serverData サーバ取得データ
   * @memberof KYMW0903Model
   */
  public updateFileName(serverData: any): void {
    this.fileName = serverData.FileName;
  }

  private toDisplayCount(count: number | string): string {
    // 0は表示しない（現行踏襲）
    // 現行では0の場合にAPIが空を返却していたが次世代では0を返却するようになった
    // しかしながら表示は現行踏襲するため置き換える
    if (count !== 0 && count !== '0') {
      return count.toString();
    } else {
      return '';
    }
  }
}
